import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols max-w-[1144px] max-w-176 w-full items-start self-stretch" }
const _hoisted_2 = { class: "flex gap-y-1" }

import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';
import { getFormInput } from '@/utils/form-input-helper';
import { ISitecoreFormGenericInput, OwnedAssistanceProduct } from '@/interfaces';
import { useAccountStore, useManageDirectDebitStore, useRoadsideAssistance } from '@/store';
import PanelTitle from '@/components/PanelTitle/PanelTitle.vue';
import ActionBar from '@/components/ActionBar/ActionBar.vue';
import { RoadsideProductType } from '@/utils/roadside-helpers';
import { scrollToElement } from '@/utils/dom-helpers';
import { asyncComputed } from '@vueuse/core';
import { RSA_ROADSIDE_EXCESS_USE } from '@/utils/roadside-helpers';
import RsaChangeRegistrationModal from './RsaChangeRegistrationModal.vue';

enum AllActionButtons {
  btnPaymentDetails = 'btnPaymentDetails',
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RsaProductDetailsHeader',
  props: {
    content: {},
    id: {},
    name: {},
    testPolicyId: {}
  },
  setup(__props: any) {

const accountStore = useAccountStore();
const rsaStore = useRoadsideAssistance();
const route = useRoute();

const props = __props;

const currentPolicy = ref<OwnedAssistanceProduct>();
const isLoading = ref<boolean>(!!props?.testPolicyId);
const actionBarContent = getFormInput(props.content, 'actionBar');
const changeRegistrationContent = getFormInput(props.content, 'changeRegistration');
const manageDirectDebitStore = useManageDirectDebitStore();
const showPaymentDetails = ref<boolean>(false);

onMounted(async () => {
  const eligibleProducts = await manageDirectDebitStore.getPortfolioAssitanceProductsForDirectDebit();
  showPaymentDetails.value =
    !!currentPolicy.value && eligibleProducts.some((x) => x.assetLineItemId === currentPolicy.value?.assetLineItemId);
});

const filteredFields = computed(() => {
  if (!currentPolicy?.value && accountStore?.identityDetails?.portfolio?.assistanceProducts) {
    getCurrentPolicy();
  }

  if (currentPolicy?.value) {
    const tempFilteredFields = {
      fields: actionBarContent.fields,
    };

    return tempFilteredFields;
  }

  return null;
});

const showPaymentButton = computed(() => {
  if (currentPolicy?.value) {
    return (
      currentPolicy.value?.roadsidePolicyType !== RoadsideProductType.Cmo &&
      currentPolicy.value.productCode !== RSA_ROADSIDE_EXCESS_USE &&
      showPaymentDetails.value
    );
  }
  return false;
});

function getCurrentPolicy() {
  if (!accountStore.identityDetails?.portfolio?.assistanceProducts) return null;
  const policyId = route.query.policyId;
  const status = route.query.status;

  const usePolicyId = (policyId?.length ?? 0) > 0 ? policyId : props.testPolicyId;
  const tempPolicy = accountStore?.identityDetails?.portfolio?.assistanceProducts.find(
    (x) => x.policyId === usePolicyId && (!status ? true : x.status === status)
  );

  currentPolicy.value = tempPolicy;
  isLoading.value = false;

  return tempPolicy;
}

const getTitle = async (rsaPolicy: OwnedAssistanceProduct) => {
  return rsaPolicy?.roadsidePolicyType !== RoadsideProductType.Cmo && rsaPolicy?.productCode !== RSA_ROADSIDE_EXCESS_USE
    ? (rsaPolicy?.tierDescription ?? '')
    : ((await rsaStore.getRsaProductContent(rsaPolicy?.productCode))?.tierDescription ?? '');
};

const getSubTitle = (rsaPolicy: OwnedAssistanceProduct) => {
  return `${
    !rsaPolicy?.isLifestyle && rsaPolicy?.vehicleDetail
      ? `${rsaPolicy?.vehicleDetail?.manufacturingYear} ${rsaPolicy?.vehicleDetail?.make?.description} ${rsaPolicy?.vehicleDetail?.model?.description} (${rsaPolicy.vehicleDetail?.registrationNumber})`
      : ''
  }`;
};

const rsaDisplayText = asyncComputed(async () => {
  const tempPolicy = getCurrentPolicy();

  let displayDetails = {
    icon: '',
    title: '',
    subTitle: '',
  };

  if (tempPolicy) {
    displayDetails.icon = require('@/assets/icons/driver-icon-ss.svg');
    displayDetails.title = await getTitle(tempPolicy);
    displayDetails.subTitle = getSubTitle(tempPolicy);
  }

  return displayDetails;
});

const onClick_ActionBarButton = (linkItem: any) => {
  if (!currentPolicy?.value) return;
  if (linkItem.name === AllActionButtons.btnPaymentDetails) {
    scrollToElement(linkItem.link.value.href, 500, -100);
  }
};

const skeletonBlocks = [
  {
    height: 26,
    width: 338,
    class: 'mb-3',
  },
  {
    height: 26,
    width: 176,
    class: 'mb-3',
  },
];

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!isLoading.value)
        ? (_openBlock(), _createBlock(FormStepInputs, {
            key: 0,
            step: {
        stepName: _ctx.name,
        formInputs: _ctx.content,
      }
          }, {
            roadsidePanelTitle: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (!isLoading.value)
                  ? (_openBlock(), _createBlock(PanelTitle, _mergeProps({ key: 0 }, _unref(getFormInput)(props.content, 'roadsidePanelTitle'), {
                      icon: { value: { src: _unref(rsaDisplayText)?.icon, alt: 'driver icon' } },
                      title: { value: _unref(rsaDisplayText)?.title },
                      subTitle: { value: _unref(rsaDisplayText)?.subTitle }
                    }), null, 16, ["icon", "title", "subTitle"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            actionBar: _withCtx(() => [
              (showPaymentButton.value && filteredFields.value)
                ? (_openBlock(), _createBlock(ActionBar, _mergeProps({ key: 0 }, filteredFields.value, {
                    outerClass: _unref(actionBarContent).outerClass,
                    innerClass: _unref(actionBarContent).innerClass,
                    handleLinkClickEvent: true,
                    onBtnClick: _cache[0] || (_cache[0] = (linkName) => onClick_ActionBarButton(linkName))
                  }), null, 16, ["outerClass", "innerClass"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["step"]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_Skeleton, { blocks: skeletonBlocks })
    ], 512), [
      [_vShow, isLoading.value]
    ]),
    _createVNode(RsaChangeRegistrationModal, {
      policy: currentPolicy.value,
      content: _unref(changeRegistrationContent)?.fields || []
    }, null, 8, ["policy", "content"])
  ], 64))
}
}

})